// extracted by mini-css-extract-plugin
export default {"addToCartControl":"QZ-z","giftCard":"RZ-z","btnContainer":"SZ-z","cartButton":"TZ-z","disabled":"UZ-z"};